import { Button, Text, View } from "../base";
import { Icon } from "../base/Icon";

type OrganizationSettingsTabProps = {
  title: string;
  description: string;
  onClickAction: () => void;
  actionLabel?: string;
  children: React.ReactNode;
  className?: string;
};

export const OrganizationSettingsTab = ({ title, description, onClickAction, actionLabel, children, className }: OrganizationSettingsTabProps) => {
  return (
    <View className={`space-y-6 ${className || ""}`}>
      <View className="flex items-start justify-between">
        <View className="flex flex-col gap-2">
          <Text className="text-2xl font-bold text-gray-900 dark:text-white">{title}</Text>
          <Text className="text-gray-600 dark:text-gray-400">{description}</Text>
        </View>
        {actionLabel && (
          <Button onClick={onClickAction}>
            <Icon
              name="add"
              size={16}
              className="mr-2"
            />
            {actionLabel}
          </Button>
        )}
      </View>

      {children}
    </View>
  );
};
